<template>
  <div
    class="time-ruler"
    :style="cellStyle"
    @mouseover="setFocusedTick(tick)"
    @mouseout="clearFocusedTick()">
    <span class="tick-mark" :style="tickMarkStyle(tick)"></span>
    <span v-if="tick.minutes() === 0" class="tick-label">{{ tick.format("H:mm") }}</span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ReservationTableTimeRuler',
  props: {
    tick: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    pxPerCell: {
      type: Number,
      required: true,
    },
    borderColorDefault: {
      type: String,
      required: true,
    },
    backgroundColorFocused: {
      type: String,
      required: true,
    },
    tickBorderWidth: {
      type: Number,
      required: true,
    },
    borderTopWidth: {
      type: Number,
      required: true,
    },
    borderBottomWidth: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('reservation', ['focusedTick']),
    cellStyle () {
      let ret = {
        float: 'left',
        height: this.height + 'px',
        width: (this.pxPerCell) + 'px',
        'line-height': this.height + 'px',
        border: '0 solid ' + this.borderColorDefault,
        'border-top-width': this.borderTopWidth + 'px',
        'border-bottom-width': this.borderBottomWidth + 'px',
        'box-sizing': 'border-box',
      }
      if (this.tick.isSame(this.focusedTick)) {
        ret['background'] = this.backgroundColorFocused
      }
      return ret
    },
  },
  methods: {
    ...mapActions('reservation', ['setFocusedTick', 'clearFocusedTick']),
    tickMarkStyle (tick) {
      let style = {
        'border-left-width': this.tickBorderWidth + 'px',
        'border-left': 'solid ' + this.borderColorDefault,
      }

      if (tick.minutes() === 0) {
        style.top = 0
        style.height = this.cellStyle.height
      } else if (tick.minutes() === 30) {
        style.top = `calc(${this.cellStyle.height} * 0.5)`
        style.height = `calc(${this.cellStyle.height} * 0.5)`
      } else {
        style.top = `calc(${this.cellStyle.height} * 0.75)`
        style.height = `calc(${this.cellStyle.height} * 0.25)`
      }
      return style
    },
  },
}
</script>

<style scoped>

.tick-mark {
  position: absolute;
}

.tick-label {
  font-size: 12px;
  padding-left: 5px;
  font-weight: bold;
  position: relative;
  z-index: 100;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Table/TimeRuler.vue